// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import echarts from 'echarts' //引入echarts

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'

import router from './router'
import store from './store'

import i18n from '@/lang' // Internation alization国际化
import '@/icons' // icon
import '@/permission' // permission control
import GlobalApi from './utils/global'
Vue.use(ElementUI, {
    size: 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
})
Vue.use(GlobalApi)
Vue.config.productionTip = false

Vue.prototype.$echarts = echarts
Vue.prototype.tableHeight = document.documentElement.clientHeight-220
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js